import { render, staticRenderFns } from "./ktp.vue?vue&type=template&id=39144802&scoped=true&"
import script from "./ktp.vue?vue&type=script&lang=js&"
export * from "./ktp.vue?vue&type=script&lang=js&"
import style0 from "./ktp.vue?vue&type=style&index=0&id=39144802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39144802",
  null
  
)

export default component.exports